// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2dspW","vLegacy":"SelectSecondary_vLegacy__1cUIt","error":"SelectSecondary_error__2s5rV","disabled":"SelectSecondary_disabled__g4coU"};